import React, { FC, useEffect } from "react";

import { Bottom, MainContainer, Top } from "./styled";
import { SpecialTableFilter } from "../SpecialTableFilter";

import { useTableSpecialFilter } from "../../hooks/table/useTableSpecialFilter";

import { MainProps } from "./types";

export const Main: FC<MainProps> = ({ bottomState = "none", bottomHeight, bottomSlot = null, children }) => {
  const [specialFilter, updateSpecialFilter] = useTableSpecialFilter();

  useEffect(() => {
    if (bottomState === "none") {
      updateSpecialFilter({
        active: false,
        attribute: undefined,
        attributeType: undefined,
        layerName: undefined,
        filterType: undefined,
        selection: undefined,
      });
    }
  }, [bottomState]); // eslint-disable-line

  return (
    <MainContainer>
      <Top data-bottom={bottomState}>{children}</Top>
      <Bottom
        data-bottom={bottomState}
        style={bottomState === "fullscreen" ? {} : { maxHeight: bottomHeight, height: bottomHeight }}
      >
        {bottomSlot}
      </Bottom>
      {specialFilter?.active && <SpecialTableFilter />}
    </MainContainer>
  );
};
